import React from 'react';
import styles from './ProfileTabs.module.css';

export type ProfileTab = 'settings' | 'inquiries';

interface ProfileTabsProps {
  activeTab: ProfileTab;
  onTabChange: (tab: ProfileTab) => void;
}

export const ProfileTabs: React.FC<ProfileTabsProps> = ({ activeTab, onTabChange }) => {
  return (
    <div className={styles.tabs}>
      <button
        className={`${styles.tab} ${activeTab === 'settings' ? styles.active : ''}`}
        onClick={() => onTabChange('settings')}
      >
        Settings
      </button>
      <button
        className={`${styles.tab} ${activeTab === 'inquiries' ? styles.active : ''}`}
        onClick={() => onTabChange('inquiries')}
      >
        My Inquiries
      </button>
    </div>
  );
};

export default ProfileTabs;
